var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90751 16.46C2.26763 15.7178 2.73315 15.1776 3.53683 15.507L5.12224 16.0954C6.39144 16.6839 7.02384 16.0954 7.66064 15.2083L10.5152 8.7174C10.8754 7.9752 10.6865 7.27692 9.88283 6.94754L7.66503 6.06042C6.86135 5.72665 6.98871 5.03277 7.34883 4.29057L9.24165 0.750861C9.60177 0.00866465 10.3396 -0.171395 11.1433 0.157982C12.755 0.821128 14.0857 1.86196 14.9465 3.40345C16.0005 5.28748 15.4735 7.90933 15.2627 9.01164C15.0519 10.114 14.3141 12.0463 13.3611 14.027C12.4081 16.012 11.5736 17.5711 10.8227 18.4538C10.0761 19.3365 8.28426 21.752 6.06645 22.2921C4.24829 22.7313 2.2852 22.3624 0.677839 21.6993C-0.125841 21.3699 -0.130233 20.6716 0.229886 19.925L1.90751 16.46Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallRight);
export default __webpack_public_path__ + "static/media/callRight.aedf77734209f81d9472bd3c628130f7.svg";
export { ForwardRef as ReactComponent };